import ApiService from "../api-service";
import { TOP, END, DEFAULT_ERROR_MESSAGE } from "@/store/config";
import { BASE_URL } from "../../../config";

import {
	FETCH_FINANCE_ACKNOWLEDGEMENTS,
	ADD_FINANCE_ACKNOWLEDGEMENTS,
	SHOW_ALERT,
	FETCH_DSTR_PENDING_SUPPORT_ENTRIES,
	FETCH_MONTHLY_DSTR_INVOICE,
	FINANCE_BULK_APPROVAL_DSTR_INVOICE
} from "../action-types";
import { fetchFinanceAcknowledgementsSuccess } from "../mutation-types";
import _get from "lodash/get";
import { _getDateTimeFormat } from "../../utils";

const state = {
	financeAcknowledgements: {
		list: [],
		offset: undefined
	}
};

export const initialState = Object.assign({}, state);

const actions = {
	[FETCH_FINANCE_ACKNOWLEDGEMENTS.action]: (
		{ commit, dispatch, rootState },
		payload
	) => {
		const endpoint = BASE_URL + "/jeet11-finance/v1.0.0/getPreviousActions";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...(payload.type === END
					? {
							o: _get(
								rootState,
								"finance.financeAcknowledgements.offset"
							)
					  }
					: {})
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(fetchFinanceAcknowledgementsSuccess, {
						...data.response,
						...payload
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},
	[ADD_FINANCE_ACKNOWLEDGEMENTS.action]: ({ rootState }, payload) => {
		const endpoint = BASE_URL + "/jeet11-finance/v1.0.0/ackPayment";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload).then(data => data);
	},
	[FETCH_DSTR_PENDING_SUPPORT_ENTRIES.action]: (
		{ rootState, dispatch },
		payload
	) => {
		const endpoint = BASE_URL + "/jeet11-finance/v1.0.0/acceptedInvoices";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[FETCH_MONTHLY_DSTR_INVOICE.action]: ({ rootState, dispatch }, payload) => {
		const endpoint =
			BASE_URL + "/jeet11-finance/v1.0.0/dstrsMonthlyGstInvoice";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[FINANCE_BULK_APPROVAL_DSTR_INVOICE.action]: (
		{ rootState, dispatch },
		payload
	) => {
		const endpoint = BASE_URL + "/jeet11-finance/v1.0.0/approveInvoices";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	}
};
const mutations = {
	[fetchFinanceAcknowledgementsSuccess](state, { data, offset, type = TOP }) {
		data = data.map(el => {
			return {
				...el,
				transferDate: _getDateTimeFormat(el.transferDate),
				createdOn: _getDateTimeFormat(el.createdOn),
				updatedOn: _getDateTimeFormat(el.updatedOn)
			};
		});
		if (type === TOP) {
			state.financeAcknowledgements = {
				list: [...data],
				offset
			};
		} else if (type === END) {
			state.financeAcknowledgements = {
				list: [...state.financeAcknowledgements.list, ...data],
				offset
			};
		}
	}
};

export default {
	namespaced: true,
	state,
	actions,
	mutations
};
